import { alpha, styled } from '@mui/material'
import { Button } from '@mui/material'
import { useScreenSize } from 'hooks/useScreenSize/useScreenSize'
import { excludedFromForwardProps } from 'utilities/styledUtil'

export const CircleButton = styled(
    Button,
    excludedFromForwardProps('isActive', 'isSign', 'isSmall'),
)<{
    isActive: boolean
    isSign?: boolean
    isSmall?: boolean
    component?: React.ElementType
}>(({ isActive, theme, isSign, isSmall }) => ({
    backgroundColor: alpha('#fff', 0.2),
    boxShadow: 'none',
    color: '#fff',
    textTransform: 'none',
    fontSize: isSign && isSmall ? 12 : isSign ? 20 : isSmall ? 28 : 46,
    padding: isSmall ? '30px 18px' : isSign ? '0px 0px' : '17px 40px',
    height: isSmall ? 50 : 100,
    width: isSmall ? 50 : 100,
    maxHeight: isSmall ? 50 : 100,
    maxWidth: isSmall ? 50 : 100,
    border: '0px solid',
    borderRadius: '100%',
    lineHeight: 1.5,
    borderColor: '#fff',

    '&:hover': {
        backgroundColor: theme.palette.info.main,
        borderColor: theme.palette.info.main,
        boxShadow: 'none',
    },
    '&:active': {
        boxShadow: 'none',
        backgroundColor: theme.palette.info.main,
        borderColor: theme.palette.info.main,
    },
    '&:focus': {
        boxShadow: 'none',
    },
    ...(isActive
        ? {
              backgroundColor: theme.palette.info.main,
              borderColor: theme.palette.info.main,
              boxShadow: 'none',
          }
        : {}),
}))
const NumberButton = ({
    number,
    onClick,
    isActive = false,
}: {
    isActive?: boolean
    number: string
    onClick: (v: string) => void
}) => {
    const { isLandscapeMobile, isMobile, isLandscapeTablet } = useScreenSize()
    return (
        <CircleButton
            isSmall={isLandscapeMobile || isMobile || isLandscapeTablet}
            isActive={isActive}
            onClick={(e) => onClick(number)}
        >
            <span>{number}</span>
        </CircleButton>
    )
}

export default NumberButton
